<template>
  <div class="calendar-event" @click="loadCalendarEvent">
    <div class="icon-container d-flex align-items-center justify-content-center"
         :class="calendarEvent.buddyId ? 'event-background__buddy' : 'event-background__global'">
      <i class="far fa-bell"></i>
    </div>
    <div class="title">
      <span class="event-date mr-3" v-show="showDate">{{ formatDate(calendarEvent.date) }}</span>
      <span class="event-name">{{ calendarEvent.title }}</span>
    </div>
  </div>
</template>

<script>
import DateFormatter from "@/mixins/DateFormatter";

export default {
  name: "EventSmall",
  mixins: [ DateFormatter ],
  props: {
    calendarEvent: Object,
    interactable: Boolean,
    showDate: Boolean,
    buddyId: Number
  },
  computed: {
    formattedTime()
    {
      if (this.event.date)
      {
        return this.formatHourMinutes(this.event.date);
      }
      else
      {
        return "";
      }
    }
  },
  methods: {
    loadCalendarEvent()
    {
      if (this.interactable && this.calendarEvent.buddyId)
      {
        this.$router.push({
          name: "event-edit", params: {
            id: this.calendarEvent.id,
          },
          query: {
            buddyId: this.calendarEvent.buddyId
          }
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.calendar-event
{
  //background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  margin-bottom: 0.66rem;

  display: flex;

  .icon-container
  {
    font-size: 30px;
    overflow: visible;

    color: $font-light;

    width: 50px;
    height: 50px;

    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  .title
  {
    padding: 10px;
    flex: 1 1;

    display: flex;
    flex-direction: row;
    align-items: center;

    font-size: 0.875rem;
    font-weight: 500;

    min-width: 0; // To make the ellipsis work https://css-tricks.com/flexbox-truncated-text/

    span
    {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .event-date
  {
    color: $primary-blue;
    font-style: italic;
    font-size: 1rem;
  }

  .event-name
  {
    font-weight: bold;
  }

  .event-background__global
  {
    background-color: $primary-blue;
  }

  .event-background__buddy
  {
    background-color: #BEBEBE;
  }
}
</style>